import React from 'react';
import authRoles from '@/app/auth/authRoles';
import Livestreaming from './Livestreaming';
import CameraRegistration from './live/CameraRegistration';
import LobbyMultiview from './live/LobbyMultiview';

const LivestreamingConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/livestreaming',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Livestreaming />
				</React.Suspense>
			),
		},
		{
			path: '/livestreaming-CameraRegistration',
			element: (
				<React.Suspense fallback={<>...</>}>
					<CameraRegistration />
				</React.Suspense>
			),
		},
		{
			path: '/multiview',
			element: (
				<React.Suspense fallback={<>...</>}>
					<LobbyMultiview />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default LivestreamingConfig;
